import styled from "styled-components";

export const Container = styled.div`
	@media screen and (min-width: 0px) {
		.text-spotlight {
			color: var(--secundary-color);
			font-weight: 600;
		}

		span.require {
			color: tomato;
			font-size: 14px;
			padding-top: 2px;
		}

		form {
			display: flex;
			flex-direction: column;
			margin-top: 3em;
			margin-bottom: 4em;

			div {
				flex: 1 1 auto;
				flex-basis: 50%;

				h3 {
					text-transform: uppercase;
					font-size: 18px;
					font-weight: bold;
				}

				label {
					display: flex;
					flex-direction: column;
					margin-bottom: 1em;

					p {
						margin: 0;
						font-size: 16px;
					}

					input,
					select,
					textarea {
						width: 100%;
						border: 1px solid #b2b2b2;
						padding-left: 10px;
						height: 45px;
						line-height: 45px;

						&::placeholder {
							color: #c8c8c8;
						}
					}

					textarea {
						height: 136px;
						line-height: normal;
					}
				}

				label.inputChecked {
					flex-direction: row;
					margin-top: 1em;
					input {
						width: 20px;
						height: 20px;
						margin-right: 10px;
					}
				}

				div {
					width: 100%;
					display: flex;
					align-items: flex-start;

					&.center-items {
						align-items: center;
					}

					label {
						flex-basis: 50%;

						& + label {
							margin-left: 2em;
						}
					}

					a {
						margin-left: 2em;
					}
				}
			}
		}

		.block-submit {
			flex-direction: column;
		}
	}

	@media screen and (min-width: 992px) {
		form {
			flex-direction: row;

			div + div {
				margin-left: 4em;
			}
		}
	}
`;
